import styled from 'styled-components';
import { colors } from '@/theme/colors';
import { MultiLineText } from '../text/MultiLineText';
import Button from '../Button';

interface AlertModalProps {
  message: string;
  onClose: () => void;
  errorStatus?: boolean;
  buttonText: string;
}

const AlertModal = ({
  message,
  onClose,
  errorStatus,
  buttonText,
}: AlertModalProps) => {
  return (
    <BackDrop>
      <ModalBox>
        <Message>
          <MultiLineText translationKey={message} />
        </Message>
        <Button
          text={buttonText}
          onClick={onClose}
          variant={errorStatus ? 'danger' : 'primary'}
          size="large"
          fullWidth
        />
      </ModalBox>
    </BackDrop>
  );
};

export default AlertModal;

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: ${colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 0 15px;
`;

const ModalBox = styled.div`
  background: ${colors.white};
  padding: 35px;
  border-radius: 15px;
  max-width: 360px;
  min-width: 288px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
`;

const Message = styled.div`
  font-weight: 700;
  font-size: 18px;
  line-height: 160%;
  margin-bottom: 35px;
  white-space: pre-line;
  color: ${colors.black};
`;
